"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseConfig_1 = require("../BaseConfig");
const Environment_1 = require("../../models/Environment");
const bleuConfig = {
    env: Environment_1.BuildEnvironment.Bleu,
    ariaCollectorUri: "https://collector.sovcloud-api.fr/Collector/3.0/",
    OneDsCollectorUri: "https://collector.sovcloud-api.fr/OneCollector/1.0/",
    publicPath: "https://teams.sovcloud-static.fr",
    telemetry: {
        tenantToken: "aa52561659c047478368f53a8843d768-9ae99eb7-876f-4b66-917d-b6570ae2c967-6954",
    },
    urls: Object.assign(Object.assign({}, BaseConfig_1.default.urls), { absoluteUrls: Object.assign(Object.assign({}, BaseConfig_1.default.urls.absoluteUrls), { brandingService: "https://middletier.teams.sovcloud.fr/beta/meetings/branding", brandingWithMeetingidService: "https://middletier.teams.sovcloud.fr/beta/meetings/brandinginfo" }) }),
    ecs: Object.assign(Object.assign({}, BaseConfig_1.default.ecs), { host: "https://c2s.config.ecs.svc.sovcloud.fr" }),
};
exports.default = bleuConfig;
